// Only anonymous login-change and sign-out markers are stored here, never credentials or personal information.
export const SIGNED_OUT_KEY = 'dtviso.customer.signed-out'
export const SESSION_CHANGED_KEY = 'dtviso.customer.session-changed'
export function createBrowserLoginState(storage) {
  const marker = () => { try { return storage.getItem(SESSION_CHANGED_KEY) } catch (_) { return null } }
  let observed = marker()
  return {
    marker,
    changed() { return observed !== marker() },
    blocked() { try { return storage.getItem(SIGNED_OUT_KEY) !== null } catch (_) { return false } },
    block() { try { storage.removeItem(SESSION_CHANGED_KEY); storage.setItem(SIGNED_OUT_KEY, String(Date.now())) } catch (_) { /* Storage may be disabled. */ } },
    allow(broadcast = true) { try { storage.removeItem(SIGNED_OUT_KEY); if (broadcast) storage.setItem(SESSION_CHANGED_KEY, Date.now() + '-' + Math.random().toString(36).slice(2)); observed = marker() } catch (_) { /* Cookie session still works. */ } },
  }
}

// Signals contain no account identifier, token or photo data. Restore never rebroadcasts.
export function applyBrowserSessionEvent(session, event) {
  if (event.newValue === null) return false
  if (event.key === SIGNED_OUT_KEY) session.clear('已在其他页面退出登录。')
  else if (event.key === SESSION_CHANGED_KEY) session.clear('已在其他页面切换登录，请刷新后继续。')
  else return false
  return true
}
